import React, { useRef } from "react";
import FormItem from "./FormItem";
import ControlComponent from "./ControlComponent";

const Control = props => {
  const { data, form, fullWidth, match, setIsValidating } = props;
  const errors = useRef({});

  const onError = error => {
    const { id } = data;
    errors.current[id] = error;
  };

  return (
    <FormItem
      errors={errors.current}
      form={form}
      fullWidth={fullWidth}
      controlData={data}
    >
      <ControlComponent onError={onError} data={data} match={match} setIsValidating={setIsValidating} />
    </FormItem>
  );
};

export default Control;



// WEBPACK FOOTER //
// ./src/containers/AdFormPage/GroupPage/GroupControls/Control/index.tsx